import { render } from "./Assets_List.vue?vue&type=template&id=1015d5aa"
import script from "./Assets_List.vue?vue&type=script&lang=js"
export * from "./Assets_List.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__